import http from './httpClient';

const Caas = {
  fetchClusterStatus: (clusterName: string) => {
    return http.get(`${import.meta.env.VITE_CAAS_V0_BASE}/cluster/upgrade-status`, {
      params: { name: clusterName },
    });
  },

  streamClusterUpgradeStatusUrl: (clusterName: string): string => {
    const base = import.meta.env.VITE_CAAS_V0_BASE.replace(/\/$/, '');
    const path = `${base}/cluster/upgrade-status/stream?name=${encodeURIComponent(clusterName)}`;

    if (/^https?:\/\//.test(path)) {
      return path;
    }

    if (typeof window === 'undefined') {
      return path;
    }

    return new URL(path, window.location.origin).toString();
  },

  fetchUpgradeEligibility: (clusterName: string) => {
    return http.get(`${import.meta.env.VITE_CAAS_V0_BASE}/cluster/upgrade-eligibility`, {
      params: { name: clusterName },
    });
  },

  fetchClusterDetails: (clusterName: string) => {
    return http.get(`${import.meta.env.VITE_CAAS_V0_BASE}/cluster/details`, {
      params: { name: clusterName },
    });
  },

  fetchClusterCheck: (clusterName: string) => {
    return http.get(`${import.meta.env.VITE_CAAS_V0_BASE}/cluster/check`, {
      params: { name: clusterName },
    });
  },

  upgradeCluster: (clusterName: string, version: string) => {
    return http.patch(
      `${import.meta.env.VITE_CAAS_V0_BASE}/cluster/upgrade`,
      {},
      {
        params: {
          name: clusterName,
          version,
        },
      }
    );
  },
};

export default Caas;
